<template>
    <div class="nav-section">
        <div class="nav-section-title">
            <i class="far fa-users"></i>
            <h3>{{ translations['general.my'] }} {{ translations['groups.plural'].toLowerCase() }}</h3>
        </div>

        <template v-if="data_loaded">
            <template v-if="orderedGroups.length > 0">
                <nav-group v-for="group in orderedGroups" :key="group.id" :group="group"></nav-group>

                <template v-if="groups.length > 10">
                    <div class="nav-btn light-text" v-if="!expanded" @click="expand(true)">
                        <i class="far fa-angle-double-down tw-mt-1 tw-ml-2 tw-pl-px" style="padding-right: 19px;"></i>
                        {{ translations['groups.show']}} {{ groups.length - 10 }} {{ translations['groups.more']}}
                    </div>
                    <div class="nav-btn light-text" v-else @click="expand(false)">
                        <i class="far fa-angle-double-up tw-mt-1 tw-ml-2 tw-pl-px" style="padding-right: 19px;"></i>
                        {{ translations['groups.show']}} {{ groups.length - 10 }} {{ translations['groups.less']}}
                    </div>
                </template>

                <div class="tw-mt-3 tw-pt-3 tw-border-t tw-border-gray-0">
                    <a href="/groups" class="nav-btn secondary-c">
                        <i class="far fa-search tw-mt-1 tw-ml-1 tw-pl-px" style="padding-right: 19px;"></i>
                        <p class="navigate-more small-text">{{ translations['groups.moregroups'] }}</p>
                    </a>
                </div>
            </template>
            <template v-else>
                <div class="tw--mt-3">
                    <p class="normal-text tw-mb-3 tw-ml-3 tw-mt-7">{{ translations['groups.not_joined_yet'] }}</p>
                    <a class="tw-block tw-ml-3 tw-mt-1" href="/groups">
                        <p class="navigate-more small-text light-text hover-opacity" style="margin-top: 0;">
                            <i class="far fa-angle-double-right tw-pr-2"></i>
                            {{ translations['groups.discover'] }}
                        </p>
                    </a>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="tw-inline-flex tw-ml-3 tw-mt-3">
                <i class="far fa-spinner fa-spin light-text"></i>
            </div>
        </template>
    </div>
</template>

<script>
    import orderBy from 'lodash.orderby';

    import Global from '../../../mixins/Global';
    import Group from '../../../lib/models/Group';

    import NavGroup from "./NavGroup.vue";
    import Channel from "@/resources/assets/js/vue/lib/models/Channel";

    export default {
        name: 'NavBoards',

        mixins: [Global],

        components: {
            'nav-group': NavGroup
        },

        data() {
            return {
                data_loaded: false,
                expanded: false,
                mine_groups: [],
            };
        },

        computed: {
            groups() {
                return this.mine_groups;
            },

            orderedGroups() {
                const ordered_groups = orderBy(this.groups, 'index');

                if (!this.expanded) {
                    return ordered_groups.slice(0, 10);
                }

                return ordered_groups;
            },
        },

        methods: {
            fetchMyGroups() {
                if (this.user) {
                    Channel.api().fetchSubscribedGroups().then((resp) => {
                        this.mine_groups = resp.response.data.data;
                        this.data_loaded = true;

                        this.$nextTick(() => Notifier.updateHTML());
                    });
                } else {
                    this.data_loaded = true;
                }
            },

            expand(bool) {
                this.expanded = bool;

                this.$nextTick(() => Notifier.updateHTML());
            },
        },

        updated() {
            if(typeof stickySidebar !== 'undefined') {
                stickySidebar.init();
            }
        },

        created() {
            this.fetchMyGroups();
        },
    };
</script>

<style lang="scss">
    .nav-btn {
        @apply tw-flex tw-items-center tw-p-3 tw-rounded tw-cursor-pointer;

        &:hover {
            @apply tw-bg-gray-100;
        }
    }
</style>
